module.exports = __webpack_public_path__ + "img/product03-zhinengcuishou.eb0fdec6.svg";